// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"156":"85f83cfdbf6510e4","343":"44ae1baec14304b8"}[chunkId] + ".css";
};